



















import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IProduct } from "@/models/products";

@Component
export default class DueDateFreeChangeField extends Vue {
  // Props

  @Prop({ required: true })
  public value!: IProduct["due_date_free_change"];

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Getters
  public get dueDateFreeChange() {
    return this.value;
  }
  // Setters
  public set dueDateFreeChange(value) {
    this.$emit("input", value);
  }
}
